import Plan from 'types/Plan';
import CurrencyCode from 'types/CurrencyCode';
import * as styles from './GiftLandingPage.module.scss';
import GiftingHeader from '../GiftingHeader';
import GiftValuePanel from '../GiftValuePanel';
import FrequentlyAskedQuestions from '../FrequentlyAskedQuestions';
import OnePercentForThePlanet from '../OnePercentForThePlanet';
import GiveAllTrailsBanner from '../GiveAllTrailsBanner';

type Props = {
  currencyCode: CurrencyCode;
  plan: Plan;
};

const GiftLandingPage = ({ currencyCode, plan }: Props) => {
  const scrollToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <>
      <GiftingHeader currencyCode={currencyCode} plan={plan} />
      <GiftValuePanel />
      <FrequentlyAskedQuestions />
      <OnePercentForThePlanet />
      <GiveAllTrailsBanner handleClick={scrollToTop} />
      <div data-bg="https://cdn-assets.alltrails.com/assets/images/gifting/scenic-overlook@2x.png" className={`${styles.bannerImage} lazyload`} />
    </>
  );
};

export default GiftLandingPage;
